import { api } from "@/lib/api";
import type { FrontendErrorDigest, FrontendUserSummary, FrontendHeatmap } from "@/observability/frontendTypes";

const DIGEST_ENDPOINT = "/observability/frontend/digest/latest";

export async function fetchLatestFrontendDigest(): Promise<FrontendErrorDigest | null> {
  try {
    return await api<FrontendErrorDigest>(DIGEST_ENDPOINT);
  } catch (error) {
    if (error instanceof Error && error.message.includes("404")) {
      return null;
    }
    throw error;
  }
}

export async function fetchFrontendUserSummary(): Promise<FrontendUserSummary> {
  return api<FrontendUserSummary>("/observability/frontend/users/summary");
}

export async function fetchFrontendHeatmap(): Promise<FrontendHeatmap> {
  return api<FrontendHeatmap>("/observability/frontend/heatmap");
}
